import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Details,
  Radios,
  Button,
  Fieldset,
  ErrorSummary,
} from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';

import {
  setStaffFleetChargepoints,
  getStaffFleetChargepoints,
} from '../../features/application/applicationJourneySlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import useTitle from '../../hooks/useTitle';

const StaffFleetChargepoints = ({ location }) => {
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;

  const [errorMsg, setErrorMsg] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const staffFleetChargepointsRedux = useSelector(getStaffFleetChargepoints);
  const currentUserData = useSelector(getUserDetails);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  const dispatch = useDispatch();

  useTitle(
    'landlordApp.StaffFleetChargepoints.s9',
    'Are the chargepoints only for the use of staff or fleet vehicles? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const errorMsgNotSelected = {
    children: copyProvider.getCopy(
      'landlordApp.StaffFleetChargepoints.s8',
      'Select yes if the chargepoints will only be used by staff or fleet vehicles'
    ),
  };

  const handleStaffFleetChargepoints = (event) => {
    dispatch(setStaffFleetChargepoints(event.target.value));
  };

  const handleBtnClick = () => {
    if (staffFleetChargepointsRedux === '') {
      setErrorMsg(errorMsgNotSelected);
      setErrorList([{ ...errorMsgNotSelected, href: '#firstOption' }]);
    } else if (staffFleetChargepointsRedux === 'No') {
      history.push('/landlordApp/commercial/unable-to-proceed');
    } else if (isFromCheckAnswers) {
      history.push('/landlordApp/check-your-answers');
    } else {
      history.push('/landlordApp/private-parking');
    }
  };
  const pageModel = (
    <div>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <span className="govuk-caption-l">
        {currentUserData != null &&
          currentUserData.business_name != null &&
          currentUserData.business_name}
      </span>
      <Fieldset
        legend={{
          children: (
            <h1 className="govuk-heading-xl">
              {copyProvider.getCopy(
                'landlordApp.StaffFleetChargepoints.s1',
                'Are the chargepoints only for the use of staff or fleet vehicles?'
              )}
            </h1>
          ),
        }}
      >
        <p className="govuk-body">
          {copyProvider.getCopy(
            'landlordApp.StaffFleetChargepoints.s2',
            'The parking must be dedicated to your staff and fleet vehicles.'
          )}
        </p>
        <Details
          summaryChildren={copyProvider.getCopy(
            'landlordApp.StaffFleetChargepoints.s3',
            'What does fleet vehicles mean?'
          )}
        >
          {copyProvider.getCopy(
            'landlordApp.StaffFleetChargepoints.s4',
            'Fleet vehicles are vehicles that are necessary for the commercial operation of the business. This can include vehicles owned, or leased, by the company or vehicles owned or leased by their suppliers.'
          )}
        </Details>
        <Radios
          errorMessage={errorMsg || null}
          idPrefix="staff-fleet-use-only"
          items={[
            {
              children: copyProvider.getCopy(
                'landlordApp.StaffFleetChargepoints.s5',
                'Make a selection'
              ),
              value: 'Yes',
              id: 'firstOption',
            },
            {
              children: copyProvider.getCopy(
                'landlordApp.StaffFleetChargepoints.s6',
                'Make a selection'
              ),
              value: 'No',
            },
          ]}
          name="staff-fleet-use-only"
          value={staffFleetChargepointsRedux}
          onChange={handleStaffFleetChargepoints}
        />
      </Fieldset>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordApp.StaffFleetChargepoints.s7',
          'Continue'
        )}
      </Button>
    </div>
  );

  return <> {pageModel} </>;
};
StaffFleetChargepoints.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

StaffFleetChargepoints.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};
export default StaffFleetChargepoints;
